import { Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./Pages/Home/Header/Header";
import Home from "./Pages/Home/Home/Home";
import Gears from "./Pages/Home/Gears/Gears";
import Blogs from "./Pages/Blogs/Blogs";
import Footer from "./Pages/Footer/Footer";
import Error404 from "./Pages/Error404/Error404";
import Login from "./Pages/Home/Login/Login";
import Register from "./Pages/Home/Login/Register/Register";
import RequireAuth from "./RequireAuth/RequireAuth";
import Inventory from "./Pages/Home/Inventory/Inventory";
import About from "./Pages/Home/About/About";
function App() {
  return (
    <div>
      <Header></Header>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/home" element={<Home></Home>}></Route>
        <Route
          path="/inventory/:inventoryId"
          element={
            <RequireAuth>
              <Inventory></Inventory>
            </RequireAuth>
          }
        ></Route>
        <Route path="/gears" element={<Gears></Gears>}></Route>
        <Route path="/blogs" element={<Blogs></Blogs>}></Route>
        <Route path="/about" element={<About></About>}></Route>
        <Route path="/login" element={<Login></Login>}></Route>
        <Route path="/register" element={<Register></Register>}></Route>
        <Route path="*" element={<Error404></Error404>}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
